var exports = {
  "Pf": "MyProfileTabUsernameSection.module__label___X0Utek",
  "o1": "MyProfileTabUsernameSection.module__actions___X0Utek",
};

module.exports = exports;
